<template>
  <span :id="tooltipId" :class="tooltipClass">
    <b-tooltip :target="tooltipId" :placement="placement" :triggers="triggers">
      <slot></slot>
    </b-tooltip>
  </span>
</template>

<script>

export default {
  name: 'Tooltip',
  components: { },
  props: {
    id: {
      type: String,
      default: null
    },
    placement: {
      type: String,
      default: 'top'
    },
    triggers: {
      type: String,
      default: 'click'
    },
    tooltipClass: {
      type: String,
      default: ''
    }
  },
  computed: {
    tooltipId () {
      return this.id || 'tip_' + this._uid
    }
  }
}
</script>
